goog.provide('el8.util.localStorage');

goog.require('el8.data.currUser');


el8.util.localStorage = function() {

  function getKey(key) {
      return 'el8/user/' + el8Globals.USER_ID + '/' + key;
  }

  function getReactKey(key) {
      return 'user/' + el8Globals.USER_ID + '/' + key;
  }

  function getItem(key) {
      return window.localStorage.getItem(getKey(key));
  }

  function getReactItem(key) {
      return window.localStorage.getItem(getReactKey(key));
  }

  function setItem(key, value) {
      window.localStorage.setItem(getKey(key), value);
  }

  return {
    setItem: setItem,
    getItem: getItem,
    getKey: getKey,
    getReactItem: getReactItem,
  };

}();
